module.exports = __webpack_public_path__ + "static/img/renZhengGif.08ae456.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/renZhengGif.gif
// module id = f5hX
// module chunks = 2